import { render, staticRenderFns } from "./creatGroup.vue?vue&type=template&id=6e5df8ee&scoped=true"
import script from "./creatGroup.vue?vue&type=script&lang=js"
export * from "./creatGroup.vue?vue&type=script&lang=js"
import style0 from "./creatGroup.vue?vue&type=style&index=0&id=6e5df8ee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5df8ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e5df8ee')) {
      api.createRecord('6e5df8ee', component.options)
    } else {
      api.reload('6e5df8ee', component.options)
    }
    module.hot.accept("./creatGroup.vue?vue&type=template&id=6e5df8ee&scoped=true", function () {
      api.rerender('6e5df8ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/groupBuy/groupGoods/creatGroup.vue"
export default component.exports